import { useIntakeForm } from "../../../useIntakeForm.js";
import type { ClientPortalApiClient } from "../../../api.js";

export function useGreenfieldIntake(input: {
  readonly api: ClientPortalApiClient;
  readonly linkId: string;
  readonly sessionToken: string;
  readonly linkStatus: string;
  readonly onStatus: (message: string | null) => void;
}) {
  return useIntakeForm({
    api: input.api,
    clientLinkId: input.linkId,
    token: input.sessionToken,
    linkStatus: input.linkStatus,
    onStatus: input.onStatus,
  });
}
